<template>
    <b-button
        variant="success"
        v-if="$temAcessoView('CTRLACS-USR-03')"
        @click.stop="atualizarUsuario()"
        class="mr-2"
    >
        <i class="fa fa-edit"></i> Atualizar Usuário
    </b-button>
</template>

<script>

export default {
    methods: {
        atualizarUsuario() {
            this.$router.push({
                name: 'Usuarios_Atualizar',
                params: { usuarioId: this.$route.params.usuarioId }
            })
        },
    },
}
</script>
